import PropTypes from 'prop-types';
import { BsArrowRepeat, BsArrowReturnLeft, BsCheckCircleFill, BsQrCode, BsStack, BsXCircleFill } from 'react-icons/bs';

import { StatCard } from '#emailCampaignFeature/components/common/CampaignStatsCards/CampaignStatsCards';

const PostMailingStatCards = ({ stats, showQr }) => (
	<div className={`grid grid-cols-2 gap-4 ${showQr ? 'md:grid-cols-6' : 'md:grid-cols-5'}`}>
		<StatCard title="Gesamt" value={stats.total} icon={BsStack} iconColor="text-text" bgColor="bg-bgBase-400" />
		<StatCard
			title="Bei der Post"
			value={stats.sent}
			icon={BsCheckCircleFill}
			iconColor="text-success-700"
			bgColor="bg-success-200"
		/>
		<StatCard
			title="In Bearbeitung"
			value={stats.processing}
			icon={BsArrowRepeat}
			iconColor="text-primary-700"
			bgColor="bg-primary-200"
		/>
		<StatCard
			title="Rückläufer"
			value={stats.returned}
			icon={BsArrowReturnLeft}
			iconColor="text-caution-700"
			bgColor="bg-caution-200"
		/>
		<StatCard
			title="Fehlgeschlagen"
			value={stats.failed}
			icon={BsXCircleFill}
			iconColor="text-warning-700"
			bgColor="bg-warning-200"
		/>
		{showQr && (
			<StatCard
				title="QR gescannt"
				value={stats.scanned}
				icon={BsQrCode}
				iconColor="text-primary-700"
				bgColor="bg-primary-200"
			/>
		)}
	</div>
);

PostMailingStatCards.propTypes = {
	stats: PropTypes.shape({
		total: PropTypes.number.isRequired,
		sent: PropTypes.number.isRequired,
		processing: PropTypes.number.isRequired,
		returned: PropTypes.number.isRequired,
		failed: PropTypes.number.isRequired,
		scanned: PropTypes.number,
	}).isRequired,
	showQr: PropTypes.bool,
};

export default PostMailingStatCards;
